"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.exportCharges = exports.useFilterRecharges = exports.filterGroupDefinitions = exports.isExcludedOrg = exports.getOrgVendors = exports.hasVendor = void 0;
var end2end_1 = require("@hudled/end2end");
var CSV = __importStar(require("csv-stringify/browser/esm/sync"));
var date_fns_1 = require("date-fns");
var get_1 = __importDefault(require("lodash/fp/get"));
var pick_1 = __importDefault(require("lodash/fp/pick"));
var uniqBy_1 = __importDefault(require("lodash/uniqBy"));
var fieldProcessors_1 = require("utils/fieldProcessors");
var filter_1 = require("utils/filter");
var formatters_1 = require("utils/formatters");
var logging_1 = require("utils/logging");
var constants_1 = require("./constants");
var hasVendor = function (recharge) { return !!recharge.rechVendorId; };
exports.hasVendor = hasVendor;
var getOrgVendors = function (recharges) { return (0, uniqBy_1.default)(recharges.map((0, pick_1.default)(['rechargedOrganizationId', 'rechVendorId'])), function (r) { return "".concat(r.rechargedOrganizationId, "|||").concat(r.rechVendorId); }); };
exports.getOrgVendors = getOrgVendors;
var isExcludedOrg = function (recharge) {
    var _a;
    return recharge.rechVendorId
        && ((_a = recharge.rechargedOrganization.excludedVendors) === null || _a === void 0 ? void 0 : _a[recharge.rechVendorId]);
};
exports.isExcludedOrg = isExcludedOrg;
// group: Vendor
// export const vendorCheck: RechargeGroupCheck = { group: 'Vendor', checkFn: (r) => (filter) => !!r.vendor === filter.value };
// export const makeVendorOption = ({ vendor }) => ({ value: vendor, label: vendor, category: 'Vendor' });
var sourceGroupDef = (0, filter_1.makeGroupDef)('Source', function (r) { var _a; return r.isManual ? 'Manual input' : (_a = r.sourceInvNumber) !== null && _a !== void 0 ? _a : 'Empty'; });
var planGroupDef = (0, filter_1.makeGroupDef)('Plan', function (r) { var _a; return (_a = r.plan) !== null && _a !== void 0 ? _a : 'None'; });
var vendorGroupDef = (0, filter_1.makeGroupDef)('Vendor', function (r) { var _a; return (_a = r.rechVendorId) !== null && _a !== void 0 ? _a : 'Empty'; });
// group: Date
var START_OF_MONTH = (0, date_fns_1.startOfMonth)(new Date());
var END_OF_MONTH = (0, date_fns_1.endOfMonth)(new Date());
var dateRangeOptions = [
    { value: { min: START_OF_MONTH, max: END_OF_MONTH }, label: (0, date_fns_1.format)(START_OF_MONTH, 'MMM yyyy'), category: 'Date' },
    {
        value: { min: (0, date_fns_1.addMonths)(START_OF_MONTH, -1), max: (0, date_fns_1.addMonths)(END_OF_MONTH, -1) },
        label: (0, date_fns_1.format)((0, date_fns_1.addMonths)(START_OF_MONTH, -1), 'MMM yyyy'),
        category: 'Date',
    },
    {
        value: { min: (0, date_fns_1.addMonths)(START_OF_MONTH, -2), max: (0, date_fns_1.addMonths)(END_OF_MONTH, -2) },
        label: "Until ".concat((0, end2end_1.getDateNice)((0, date_fns_1.addMonths)(END_OF_MONTH, -2))),
        category: 'Date',
    },
];
var dateGroupDef = {
    group: 'Date',
    checkFn: function (r) { return function (filter) { var _a, _b; return !!r.payDate && (new Date(r.payDate) <= ((_a = filter.value) === null || _a === void 0 ? void 0 : _a.max) && new Date(r.payDate) >= ((_b = filter.value) === null || _b === void 0 ? void 0 : _b.min)); }; },
    makeOptions: function () { return dateRangeOptions; },
};
var DISCOUNT_RANGE_OPTIONS = [
    { value: { min: -Infinity, max: 0 }, label: '< 0%', category: 'Discount' },
    { value: { min: 0, max: 10 }, label: '0% to < 10%', category: 'Discount' },
    { value: { min: 10, max: 20 }, label: '10% to < 20%', category: 'Discount' },
    { value: { min: 20, max: 30 }, label: '20% to < 30%', category: 'Discount' },
    { value: { min: 30, max: 100.1 }, label: '> 30%', category: 'Discount' },
];
var discountGroupDef = {
    group: 'Discount',
    checkFn: function (r) { return function (filter) { var _a, _b; return !!r.discount && r.discount >= ((_a = filter.value) === null || _a === void 0 ? void 0 : _a.min) && r.discount < ((_b = filter.value) === null || _b === void 0 ? void 0 : _b.max); }; },
    makeOptions: function (recharges) {
        var allDiscounts = recharges.map(function (r) { var _a; return (_a = r.discount) !== null && _a !== void 0 ? _a : 0; });
        var maxDiscount = Math.max.apply(Math, __spreadArray([], __read(allDiscounts), false));
        var minDiscount = Math.min.apply(Math, __spreadArray([], __read(allDiscounts), false));
        return DISCOUNT_RANGE_OPTIONS.filter(function (item) { return item.value.min < maxDiscount && item.value.max > minDiscount; });
    },
};
exports.filterGroupDefinitions = [vendorGroupDef, dateGroupDef, discountGroupDef, planGroupDef,
    sourceGroupDef];
exports.useFilterRecharges = (0, filter_1.makeUseFilterItems)([(0, get_1.default)('rechargedOrganization.name'), (0, get_1.default)('sourceInvNumber'), (0, get_1.default)('plan'), (0, get_1.default)('details'), (0, get_1.default)('vendor')], exports.filterGroupDefinitions);
var CHARGES_HEADER = ['status', 'vendor', 'organization', 'date', 'sourceInvoice', 'plan', 'details',
    'billingStartAndEnd', 'listPrice', 'discount', 'partnerPrice'];
var CHARGES_MAPPER = {
    status: function (item) { return constants_1.RECHARGER_STATUS_MAPPER[item.rechargerStatus].text; },
    vendor: function (item) { return item === null || item === void 0 ? void 0 : item.rechVendorId; },
    organization: function (item) { return item.rechargedOrganization.name; },
    date: function (item) { return item.payDate && (0, end2end_1.getDateNice)(new Date(item.payDate)); },
    sourceInvoice: function (item) { return item.sourceInvNumber; },
    billingStartAndEnd: function (item) { return item.startDate && item.endDate
        && "".concat((0, end2end_1.getDateNice)(item.startDate.toDate()), " - ").concat((0, end2end_1.getDateNice)(item.endDate.toDate())); },
    listPrice: function (item) { return item.listPriceInAccFirmCurrency.toFixed(2); },
    discount: function (item) { return "".concat(item.discount && "".concat((0, end2end_1.toFixedDigits)(1, 1)(item.discount), "%")); },
    partnerPrice: function (item) { return item.amountInAccFirmCurrency.toFixed(2); },
};
var exportCharges = function (items, fileName) {
    var rows = items.map((0, fieldProcessors_1.makeCsvRowGenerator)(CHARGES_HEADER, CHARGES_MAPPER, true));
    try {
        (0, fieldProcessors_1.saveAsCSV)(CSV.stringify(__spreadArray([CHARGES_HEADER.map(formatters_1.camelToProper)], __read(rows), false)), fileName);
    }
    catch (e) {
        (0, logging_1.logError)(e);
    }
};
exports.exportCharges = exportCharges;
